const { http, HttpResponse } = window.MockServiceWorker;
import { umbMediaTypeMockDb } from '../../db/media-type.db.js';
import { UMB_SLUG } from './slug.js';
import { umbracoPath } from '@umbraco-cms/backoffice/utils';

export const itemHandlers = [
	http.get(umbracoPath(`/item${UMB_SLUG}/search`), ({ request }) => {
		const url = new URL(request.url);
		const query = url.searchParams.get('query') ?? '';
		const skip = Number(url.searchParams.get('skip')) || 0;
		const take = Number(url.searchParams.get('take')) || 100;

		const response = umbMediaTypeMockDb.item.search(query, skip, take);

		return HttpResponse.json(response);
	}),

	http.get(umbracoPath(`/item${UMB_SLUG}`), ({ request }) => {
		const ids = new URL(request.url).searchParams.getAll('id');
		if (!ids) return;
		const items = umbMediaTypeMockDb.item.getItems(ids);
		return HttpResponse.json(items);
	}),

	http.get(umbracoPath(`/item${UMB_SLUG}/folders`), ({ request }) => {
		const url = new URL(request.url);
		const skip = Number(url.searchParams.get('skip')) || 0;
		const take = Number(url.searchParams.get('take')) || 100;

		const allItems = umbMediaTypeMockDb.getAll();
		const folders = allItems.filter((item) => item.isFolder);
		const paged = folders.slice(skip, skip + take);

		return HttpResponse.json({
			items: paged.map((item) => ({ id: item.id, name: item.name, icon: item.icon, flags: item.flags })),
			total: folders.length,
		});
	}),

	http.get(umbracoPath(`/item${UMB_SLUG}/allowed`), ({ request }) => {
		const url = new URL(request.url);
		const fileExtension = url.searchParams.get('fileExtension');
		if (!fileExtension) return;

		const skip = Number(url.searchParams.get('skip')) || 0;
		const take = Number(url.searchParams.get('take')) || 100;

		const response = umbMediaTypeMockDb.getAllowedByFileExtension(fileExtension, skip, take);

		return HttpResponse.json(response);
	}),
];
